import { createListenerMiddleware, type Dispatch } from "@reduxjs/toolkit";

import type { NotifyNodeDesignsEvent } from "../../reducer/events.ts";
import { type NautilusStateAction } from "../nautilusActions.ts";
import type { NautilusDesignerState } from "../nautilusState.ts";
import type { EventQueue } from "./eventQueue.ts";
import { isNodeAction } from "./shared.ts";

export interface EventPublishingListenerOptions {
  eventQueue: EventQueue;
  publishEvent: NotifyNodeDesignsEvent;
}

export const eventPublishingListenerCreate = ({ eventQueue, publishEvent }: EventPublishingListenerOptions) => {
  const listener = createListenerMiddleware<NautilusDesignerState, Dispatch<NautilusStateAction>>();
  listener.startListening({
    predicate: isNodeAction,
    effect: async () => {
      let event = eventQueue.dequeue();
      while (event) {
        publishEvent(event);
        event = eventQueue.dequeue();
      }
    },
  });
  return listener;
};
